<template>
  <div class="tab-container" :style="{ height: startHeight }">

    <h3 v-if="tabs.length === 0"> Deve existir pelo menos uma "aba"</h3>

    <div v-else class="tab-header">

      <div v-for="(tab, index) in tabs" :key="index" @click="activate(index)" class="tab-headers" :id="tab.id">
        <div class="tab-header-content" :class="{'tabs-active': tab.visible}">
          <span>{{ tab.name }}</span>
          <span
              v-if="tab.quantity"
              class="ml-2 quantity-badge text-white"
          >
            {{ tab.quantity }}
          </span>
        </div>
      </div>

    </div>

    <div class="tabs">
      <slot/>
    </div>

  </div>
</template>

<script>
  import GetAccount from '@/mixins/GetAccount.vue';
  export default {
    computed: {
      getHeight() {
        return this.startHeight
      }
    },
    data() {
      return {
        tabs: []
      }
    },
    methods: {
      activate(index) {
        this.tabs.forEach(tab => tab.visible = false)
        let tab = this.tabs.find((tab, i) => index === i)
        tab.visible = true
        this.$emit('selected', tab.id || tab.name)
      }
    },
    mixins: [GetAccount],
    mounted() {
      this.tabs = this.$children.filter(child => child.$name() === 'Tab')
      let index = this.tabs.findIndex(tab => tab.startActive)
      if (index >= 0)
        this.tabs[index].visible = true
      else if (this.tabs.length > 0)
        this.tabs[0].visible = true
    },
    name: 'TabContainer',
    props: {
      startHeight: { default: '', type: String }
    }
  }
</script>

<style scoped lang="scss">
  @import "./src/assets/utilities/variables";

  .tab-container {
    margin-bottom: 24px;
  }

  .tab-header {
    display: flex;
    flex-direction: row;
  }

  .tab-headers {
    position: relative;
    height: 44px;
    font-size: 14px;
    font-weight: 600;
    width: 200px;
    text-align: center;
    background: var(--background-tab);
    border: 1px solid var(--border-color);
    color: var(--tab-text-color);
    cursor: pointer;
    &:first-child {
      border-top-left-radius: 5px;
    }
    &:last-child {
      border-top-right-radius: 5px;
    }
  }

  .tab-header-content {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    &:first-child {
      border-top-left-radius: 5px;
    }
    &:last-child {
      border-top-right-radius: 5px;
    }
  }

  .tabs-active {
    background: var(--tab-active-bg);
    font-weight: bold;
    color: var(--tab-text-active);
    border-bottom: solid var(--tab-border-active) 3px;
    height: 45px;
  }

  .quantity-badge.sp-color {
    background-color: $sp-color;
  }

  .quantity-badge {
    display: inline-block;
    padding: 0.3rem 0.6rem;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 1rem;
    background-color: $btn-primary;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  }

</style>
